export default class DateUtilities {
  static getDateTwoDaysAgo() {
    let date = new Date()
    date.setDate(date.getDate() - 2)
    return date
  }
}
